'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Submenu SelectBox
 *
 * @class
 */

class TabSubNavSelectBox extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'name': 'no name',
                'description': '',
                'list': [],
                'weight': 0
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__tab__subnav__selectbox js-editor__tab__subnav__sortable float' data-weight='<%- weight %>'>
                <select class="editor__tab__subnav__selectbox__select editor__tab__subnav__selectbox__select--single js-tab__subnav__select">
                    <% _.each(list, function(option){ %>
                        <option value='<%- option["value"] %>' name='<%- option["name"] %>' <%= (initValue == option["value"]) ? "selected" : "" %>><%- option["name"] %></option>
                    <% }); %>
                </select>
            </div>
        `;

        super.render();

        // EVENTS
        $('.js-tab__subnav__select',this.$el).on('change', this._valuechanged);
    }

    _valuechanged(e){
        $(e.currentTarget).blur(); // blur to get rid of the focus
        $(e.currentTarget).trigger('Cioui:SubNavTool:value', $(e.currentTarget).val());
        $(e.currentTarget).trigger('Cioui:SubNavTool:label', $(e.currentTarget).attr("name"));
    }

    setValue(value){
        $('.js-tab__subnav__select', this.$el).val(value).blur();
    }
}
module.exports = TabSubNavSelectBox;
